import { useDispatch } from 'react-redux'
import { t } from '../../utils/i18n'
import { closePopover } from '../../actions'

const InfoPopover = () => {
  const dispatch = useDispatch()

  return (
    <div title="info" className="velorbis-customizer-space-dist-v">
      <p>this will be a table here</p>
      <div className="velorbis-customizer-popover-buttons">
        <button
          className="velorbis-customizer-button velorbis-customizer-button-secondary"
          onClick={() => dispatch(closePopover())}
        >
          {t('close')}
        </button>
      </div>
    </div>
  )
}

export default InfoPopover
